export default "__VITE_ASSET__BAHTVbiW__"